// extracted by mini-css-extract-plugin
module.exports = {"root":"CircularProgress_root__2JEuJ","svg":"CircularProgress_svg__14uYV","animation_circular_progress":"CircularProgress_animation_circular_progress__C_yww"};